module.exports = __webpack_public_path__ + "img/vacaciones-spain.2676b3a8.jpeg";